import format from 'root-core/utils/text/stringFormatFilter.js'
import * as validations from '../../../validations.js'
import spacecase from 'root-core/utils/text/spacecase.js'

export default function (config) {

  function present (field) {
    return validations.required((value, object, property) =>
      format(
        config.errorMessages.required,
        field || spacecase(property)
      )
    )
  }

  function termsChecked () {
    return function (value) {
      if (!value) {
        return config.errorMessages.termsAndConditions
      }
    }
  }

  function minLength (length, field) {
    return function (value, is, object, property) {
      if (value.length < length) {
        return format(
          config.errorMessages.minLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function maxLength (length, field) {
    return function (value, is, object, property) {
      if (value.length > length) {
        return format(
          config.errorMessages.maxLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function pattern (regex, field) {
    return function (value, is, object, property) {
      if (!regex.test(value)) {
        return format(
          config.errorMessages.pattern,
          field || spacecase(property)
        )
      }
    }
  }

  function creditCardName (field) {
    return function (value, is) {
      is(present(field)) &&
        is(minLength(2, field)) &&
        is(maxLength(30, field)) &&
        is(pattern(/^[a-zA-Z ]+$/, field))
    }
  }

  function reference (field) {
    return function (value, is) {
      is(present(field)) && is(maxLength(30, field))
    }
  }

  return {
    payment: {
      termsAndConditions: termsChecked(),
    },
    thirdPartyCreditCardDetails: {
      nameOnCard: creditCardName(),
      cardType: present(),
    },
    paymentReference: {
      reference: reference(),
    },
  }
}
